import { CliError } from "@/lib/cli/cli-error";
import { FOLLOW_RETRY_CAP_SECONDS } from "./follow-retry-constants";

export function followRetryDelay(
  error: CliError,
  failures: number,
  random: () => number,
): number {
  const exponential = Math.min(
    FOLLOW_RETRY_CAP_SECONDS,
    2 ** Math.min(failures - 1, 30),
  );
  const jittered = exponential / 2 + random() * (exponential / 2);
  // Retry-After is the server telling us when it will be ready: honoured whole,
  // and merely spread on top so followers do not wake as one.
  const retryAfter = Math.max(0, error.details.retryAfterSeconds ?? 0);
  return Math.max(jittered, retryAfter + random() * (exponential / 2));
}
